import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../Components/Tabs';
import ServiceEstimateScreen from './ServiceEstimateScreen';
import InvoiceBillScreen from './InvoiceBillScreen';
import InvoiceReceiptScreen from './InvoiceReceiptScreen';
import RecurringInvoiceListScreen from './RecurringInvoiceListScreen';
import BillingReceiptEstimateController from '../../../Controllers/AdminScreens/Invoices/BillingReceiptEstimateController';
const BillingReceiptEstimateScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    const {
        serviceEstimateList,
        loading,
        error,  
        serviceEstimateRefresh,
        invoiceList,
        invoiceError,
        invoiceLoading,invoiceRefresh,
        receiptList,
        receiptError, receiptLoading,
        receiptRefresh,
        recurringInvoiceList,recurringInvoiceLoading,recurringInvoiceError,recurringInvoiceRefresh
    } = BillingReceiptEstimateController();

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.invoices || {};

        const tabPermissions = [
            { name: "Service Estimates", keys: ["estimate_create", "estimate_edit", "estimate_del"]},
            { name: "Invoices", keys: ["invoice_create", "invoice_edit", "invoice_del"]},
            { name: "Recurring Invoices", keys: ["invoice_create", "invoice_edit", "invoice_del"]},
            { name: "Receipt", keys: ["receipt_gen", "receipt_edit"]}
        ]

        const disabledTabIndices = tabPermissions
                .map((tab, index) => {
                    const isDisabled = tab?.keys.every(key => per_name_sub_json?.[key] !== 1);
                    return isDisabled ? index : null;
                })
                .filter(index => index !== null) // remove all null values
        setDisabledTabs(disabledTabIndices);

        if (disabledTabIndices.includes(selectedTab)) {
            const firstEnabledTab = tabPermissions.findIndex((_, index) => !disabledTabIndices.includes(index));
            setSelectedTab(firstEnabledTab !== -1 ? firstEnabledTab : 0);
        }

    },[selectedTab])

    const handleTabChange = (index) => {
        if (disabledTabs.includes(index)) return;
        setSelectedTab(index);
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:10}}>
                <h2 className='title'>Invoices</h2>
            </div>
            
            <div >
                <Tabs tabs={['Service Estimates','Invoices','Recurring Invoices','Receipt']}
                selectedIndex={selectedTab}
                onTabChange={handleTabChange}
                disabledTabs={disabledTabs}>
                    {selectedTab === 0 && !disabledTabs.includes(0) && <ServiceEstimateScreen serviceEstimateList={serviceEstimateList} loading={loading} error={error} onRefresh={serviceEstimateRefresh} /> }
                    {selectedTab === 1 && !disabledTabs.includes(1) && <InvoiceBillScreen invoiceList={invoiceList} loading={invoiceLoading} error={invoiceError} onRefresh={invoiceRefresh}/> }
                    {selectedTab === 2 && !disabledTabs.includes(2) && <RecurringInvoiceListScreen invoiceList={recurringInvoiceList} loading={recurringInvoiceLoading} error={recurringInvoiceError} onRefresh={recurringInvoiceRefresh}/> }
                    {selectedTab === 3 && !disabledTabs.includes(3) && <InvoiceReceiptScreen receiptList={receiptList} loading={receiptLoading} error={receiptError} onRefresh={receiptRefresh}/> }
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default BillingReceiptEstimateScreen;